export const services = {
  headers: {
    requestedService: "Requested service",
  },
  actions: {
    discardRequest: "Discard request",
  },
  storeInactiveTitle: "The services store is not active",
  storeInactiveDesc1:
    "To receive requests for experiences and add-on services, you need to activate your store.",
  storeInactiveDesc2:
    "Once activated, your guests can request services directly from WhatsApp.",
  activateStoreBtn: "Activate services store",

  noServicesDesc1:
    "Enable Experiences by setting up your add-on services: breakfast, tours, transfers, or whatever you offer.",
  noServicesDesc2:
    "Your guests will see them right after check-in, directly in WhatsApp.",
  addFirstServiceBtn: "Add my first experience or service",
};
